import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/account-setup/accesslevelrule'
import pathMap from 'src/paths/PathMap_AccountSetup'

class AccessLevelRuleRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACCESS_LEVEL_RULE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACCESS_LEVEL_RULE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACCESS_LEVEL_RULE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACCESS_LEVEL_RULE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AccessLevelRuleRoute
